import React, { useContext } from "react";
import LocaleContext from "./LocaleContext";
import allLocales from "./locale";
function Header(props) {
    const { curMonth, prevMonthHandler, nextMonthHandler, todayHandler } = props;
    const localeContext = useContext(LocaleContext);
    const CalendarContext = allLocales[localeContext.locale];
    return React.createElement("div", { className: "calendar-header" },
        React.createElement("div", { className: "calendar-header-left" },
            React.createElement("div", { className: "calendar-header-icon", onClick: prevMonthHandler }, "<"),
            React.createElement("div", { className: "calendar-header-value" }, curMonth.format(CalendarContext.formatMonth)),
            React.createElement("div", { className: "calendar-header-icon", onClick: nextMonthHandler }, ">"),
            React.createElement("button", { className: "calendar-header-btn", onClick: todayHandler }, CalendarContext.today)));
}
export default Header;
